import { SvgIcon } from '@mui/material'

const PhSensor = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.889 8.38768C14.8537 4.74811 11.8719 2 11.8719 2C11.8719 2 5 8.17107 5 14.5043C5 18.0918 8.07666 21 11.8719 21C14.5467 21 16.8645 19.5555 18 17.4467"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.7212 15.2364V10H15.5112V12.2756H18.1218V10H18.9144V15.2364H18.1218V12.9531H15.5112V15.2364H14.7212Z"
        fill="currentColor"
      />
      <path
        d="M10 16.7091V11.3091H10.7466V11.9457H10.8105C10.8548 11.8639 10.9188 11.7693 11.0023 11.6619C11.0858 11.5545 11.2017 11.4608 11.35 11.3807C11.4983 11.2988 11.6943 11.2579 11.9381 11.2579C12.2551 11.2579 12.5381 11.338 12.7869 11.4983C13.0358 11.6585 13.231 11.8895 13.3724 12.1912C13.5156 12.4929 13.5872 12.8559 13.5872 13.2804C13.5872 13.7048 13.5165 14.0687 13.375 14.3721C13.2335 14.6738 13.0392 14.9065 12.792 15.0702C12.5449 15.2321 12.2628 15.313 11.9457 15.313C11.7071 15.313 11.5119 15.273 11.3602 15.1929C11.2102 15.1128 11.0926 15.019 11.0074 14.9116C10.9222 14.8042 10.8565 14.7088 10.8105 14.6253H10.7645V16.7091H10ZM10.7491 13.2727C10.7491 13.5488 10.7892 13.7909 10.8693 13.9988C10.9494 14.2068 11.0653 14.3696 11.217 14.4872C11.3688 14.6031 11.5545 14.6611 11.7744 14.6611C12.0028 14.6611 12.1938 14.6005 12.3472 14.4795C12.5006 14.3568 12.6165 14.1906 12.6949 13.9809C12.775 13.7713 12.8151 13.5352 12.8151 13.2727C12.8151 13.0136 12.7759 12.7809 12.6974 12.5747C12.6207 12.3684 12.5048 12.2057 12.3497 12.0863C12.1963 11.967 12.0045 11.9074 11.7744 11.9074C11.5528 11.9074 11.3653 11.9645 11.2119 12.0787C11.0602 12.1929 10.9452 12.3523 10.8668 12.5568C10.7884 12.7613 10.7491 13 10.7491 13.2727Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
)

export default PhSensor
